import React from 'react';
import {StyleSheet, View} from 'react-native';

import CartButton from '../components/CartButton';
import ProductImage from '../images/brand/giftCardsShop/product-image.png';
import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import theme from '../style/theme';
import {toAUD} from '../utils/functions';
import {isGiftCardProduct} from '../utils/giftCards';
import {makeByLineText} from '../utils/products';

import Text from './ui-controls/Text';
import HorizontalTile from './TileAbbreviatedHorizontal';

const TileContent = ({
  item,
  byline,
  showPreviousQuantity,
}: {
  item: any;
  byline: string;
  showPreviousQuantity: boolean;
}) => (
  <>
    <Text style={styles.itemText}>{item.name}</Text>
    {showPreviousQuantity ? (
      <View style={styles.previousQuantityRow}>
        <Text style={styles.previousQuantityText}>Previous Order Qty: </Text>
        <Text style={styles.previousQuantityText}>{item.quantity}</Text>
      </View>
    ) : (
      <View style={styles.previousQuantityRow}>
        <Text style={styles.previousQuantityText}> </Text>
      </View>
    )}
    <View style={styles.priceButtonRow}>
      <View>
        <Text style={styles.itemQty}>{byline}</Text>
        <View style={styles.priceLine}>
          <Text style={styles.price}>{toAUD(item.sell_price_cents)}</Text>
          <Text style={styles.priceUnit}> each</Text>
        </View>
      </View>
      {!isGiftCardProduct(item) && (
        <View style={styles.basketButtons}>
          <CartButton innerStyle={{paddingVertical: 2}} item={item} />
        </View>
      )}
    </View>
  </>
);

type ProductTileAbbreviatedHorizontalProps = {
  item: any;
  pressCallback?: (item: any) => void;
  showPreviousQuantity?: boolean;
};
const ProductTileAbbreviatedHorizontal = ({
  item,
  pressCallback,
  showPreviousQuantity = false,
}: ProductTileAbbreviatedHorizontalProps) => {
  const navigation = useAppNavigation();

  const handlePress = () =>
    pressCallback
      ? pressCallback(item)
      : navigation.navigate(AppRoute.PRODUCT, {product: item});

  const byline = makeByLineText(item);

  const isGiftCard = isGiftCardProduct(item);
  const imageUri = !isGiftCard
    ? item.links.medium_image || item.links.image
    : undefined;
  const imageSource = isGiftCard ? ProductImage : undefined;

  return (
    <HorizontalTile
      key={item.id}
      onPress={handlePress}
      testID="wishlist-screen-flatlist-product-tile"
      imageUri={imageUri}
      imageSource={imageSource}
      content={
        <TileContent
          item={item}
          byline={byline}
          showPreviousQuantity={showPreviousQuantity}
        />
      }
    />
  );
};

export default ProductTileAbbreviatedHorizontal;

const styles = StyleSheet.create({
  // Text side
  rightCol: {
    flex: 4,
    paddingHorizontal: 12,
    paddingVertical: 4,
    alignSelf: 'stretch',
    justifyContent: 'space-between',
  },
  itemText: {
    color: theme.colour.text.heading.primary,
    fontSize: 16,
    fontWeight: 'bold',
  },
  priceButtonRow: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginBottom: 4,
    width: '100%',
  },
  itemQty: {
    color: 'grey',
    fontSize: 12,
  },
  priceLine: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  originalPrice: {
    color: 'grey',
    fontSize: 12,
    fontWeight: 'bold',
  },
  price: {
    fontSize: 12,
    color: theme.colour.text.heading.primary,
  },
  priceUnit: {
    fontSize: 12,
    color: theme.colour.text.heading.primary,
  },
  basketButtons: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  previousQuantityRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 4,
  },
  previousQuantityText: {
    fontSize: 12,
    color: theme.colour.text.heading.primary,
    fontStyle: 'italic',
  },
});
